import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SidebarComponent } from './sidebar/sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';
import { FooterComponent } from './footer/footer.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { SharedModule } from '../shared/shared.module';
import { TopbarModalComponent } from './topbar-modal/topbar-modal.component';
import { NgxCopilotModule } from 'ngx-copilot';
import { SharedService } from '@noe/services/shared.service';
import { SharedCargarDocumentosService } from '@noe/services/sharedCargarDocumentos.service';
import { SharedAvatarService } from '@noe/services/sharedAvatar.service';
import { SharedActivarCargaDocumento } from '@noe/services/sharedActivarCargaDocumento.service';
import { SharedPlanService } from '@noe/services/sharedPlan.service';
import { SharedActivarTitle } from '@noe/services/sharedActivarTitle.service';
import { SharedCerrarVisorService } from '@noe/services/sharedCerrarVisor.service';
import { SharedCerrarVisorPdfService } from '@noe/services/sharedCerrarVisorPdf.service';


@NgModule({
  declarations: [
    SidebarComponent, 
    TopbarComponent, 
    TopbarModalComponent, 
    FooterComponent, 
    NotificationsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgxCopilotModule
  ],
  exports: [
    TopbarComponent,
    TopbarModalComponent,
    SidebarComponent,
    FooterComponent,
    NotificationsComponent,
    NgxCopilotModule
  ],
  providers: [SharedService, SharedCerrarVisorPdfService, SharedCerrarVisorService, SharedCargarDocumentosService, SharedAvatarService, SharedActivarCargaDocumento, SharedActivarTitle, SharedPlanService],
})
export class CoreModule { }
